// Imports custom
import {
    CustomTableCheck
} from 'common'

export const MoraPendienteTable = ({ useFetchInit }) => {

    const {
        Forms,
        globalStates
    } = useFetchInit

    const { formOpeningMode } = globalStates

    // ------------------------------------------------ Formularios
    const { FormRequestGlobal } = Forms
    const { formState } = FormRequestGlobal

    const isReadOnly = (formOpeningMode === 'READONLY')

    const columnConfig = [
        {
            headerName: '',
            width: 60,
            checkboxSelection: !isReadOnly, // bloquea checks para modo read-only (el administrador nunca crea la gestion).
            headerCheckboxSelection: !isReadOnly,
            pinned: 'left',
            suppressMenu: true,
            sortable: false,
            filter: false,
            resizable: false
        },
        { field: 'no_cuota', headerName: 'No. CUOTA', minWidth: 150, filter: true },
        { field: 'fecha_pago', headerName: 'F. PAGO', minWidth: 150, filter: true },
        { field: 'fecha_cierre', headerName: 'F. CIERRE', minWidth: 150, filter: true },
        { field: 'dias_atraso', headerName: 'DIAS ATRASO', minWidth: 150, filter: true },
        {
            field: 'mora_cuota', headerName: 'MORA CUOTA', minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        {
            field: 'mora_pendiente', headerName: 'MORA AL SOLICITAR', minWidth: 180, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        {
            field: 'porcentaje_exonerado', headerName: '% EXONERADO', minWidth: 150, filter: true,
            cellRenderer: (params) => parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' %'
        },
        {
            field: 'monto_exonerado', headerName: 'MONTO EXONERADO', minWidth: 180, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { field: 'aprobacion_check', headerName: 'ESTADO', minWidth: 150, filter: true },
    ]

    return (
        <div className='content'>
            <CustomTableCheck
                // El administrador solo consulta: la seleccion de cuotas ya la hizo el gestor al
                // crear la gestion. Se muestra siempre formState.exoneraciones (nunca se pide via
                // fetch en este lado).
                rowConfig={formState.exoneraciones}
                columnConfig={columnConfig}
            />
        </div>
    )
}
